import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideStore, Store } from '@ngrx/store';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { appRoutes } from './app.routes';
import { bookingReducer } from './booking/reducers/booking.reducer';
import { currentBookingReducer } from './booking/reducers/current-booking.reducer';
import { d2dReducer } from './booking/reducers/d2d-booking.reducer';
import { flightReducer } from './booking/reducers/flight.reducer';
import { flybackReducer } from './booking/reducers/flyback.reducer';
import { hubDropReducer } from './booking/reducers/hubdrop.reducer';
import { milesAndMoreReducer } from './booking/reducers/milesAndMore.reducer';
import { oldBookingInfoReducer } from './booking/reducers/old-booking-info.reducer';
import { updatePanelReducer } from './booking/reducers/panel.reducer';
import { priceReducer } from './booking/reducers/price.reducer';
import { threeDS2Reducer } from './booking/reducers/threeDS2.reducer';
import { timeslotReducer } from './booking/reducers/timeslot.reducer';
import { upsellBookingReducer } from './booking/reducers/upsell-booking.reducer';
import { copyReducer } from './shared/reducers/copy.reducer';
import { flightFinderReducer } from './shared/reducers/flight-finder.reducer';
import { loadedStatusReducer } from './shared/reducers/loading-status.reducer';
import { partnerReducer } from './shared/reducers/partner.reducer';
import { userAgentReducer } from './shared/reducers/user-agent.reducer';
import { userReducer } from './shared/reducers/user.reducer';
import { utilityReducer } from './shared/reducers/utility.reducer';
import { AirportCopyService } from './shared/services/app-airport-copy.service';
import { CopyService } from './shared/services/app-copy.service';
import { ApplicationInsightsService } from './shared/services/app-insights.service';
import { DataStorageService } from './shared/services/data-storage.service';
// import { REQUEST, RESPONSE } from 'express.tokens';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { EventsService } from './booking/services/events.service';
import { LoginService } from '@shared/services/login.service';
import { ErrorHandler } from '@shared/services/error-handler.service';
import { BookingService } from './booking/services/booking.service';
import { FlightDetailsService } from '@shared/services/flight-details.service';
import { PriceService } from './booking/services/price.service';
import { UtilityService } from '@shared/services/utility.service';
import { TimeslotService } from './booking/services/timeslots.service';
import { AbandonmentService } from '@shared/services/abandonment.service';
import { TooltipService } from '@shared/services/tooltip.service';
import { AppLoaderService } from '@shared/services/app-loader.service';
import { UserAgentService } from '@shared/services/user-agent.service';
import { SharedService } from '@shared/services/shared-service.service';
import { ExternalScriptsService } from '@shared/services/external-scripts.service';
import { provideClientHydration } from '@angular/platform-browser';


export const appConfig: ApplicationConfig = {
  providers: [
    provideClientHydration(),
    provideHttpClient(withFetch()),
    provideRouter(appRoutes),
    provideStore({
      partnerReducer,
      copyReducer,
      flightReducer,
      d2dReducer,
      bookingReducer,
      userReducer,
      currentBookingReducer,
      upsellBookingReducer,
      priceReducer,
      threeDS2Reducer,
      updatePanelReducer,
      loadedStatusReducer,
      flightFinderReducer,
      timeslotReducer,
      hubDropReducer,
      flybackReducer,
      userAgentReducer,
      milesAndMoreReducer,
      utilityReducer,
      oldBookingInfoReducer,
    }),
    provideStoreDevtools(),
    ApplicationInsightsService,
    DataStorageService,
    CopyService,
    AirportCopyService,
    EventsService,
    LoginService,
    ErrorHandler,
    BookingService,
    DataStorageService,
    FlightDetailsService,
    PriceService,
    CopyService,
    UtilityService,
    TimeslotService,
    AbandonmentService,
    TooltipService,
    AppLoaderService,
    UserAgentService,
    SharedService,
    ExternalScriptsService,
    ApplicationInsightsService,
    provideAnimations(),
    BrowserAnimationsModule,
    // You can inject real request/response data based on your needs
    // {
    //   provide: REQUEST,
    //   useValue: { url: '/current/url', headers: { 'Authorization': 'Bearer token' } }  // Simulated request data
    // },
    // {
    //   provide: RESPONSE,
    //   useValue: { statusCode: 200, body: { message: 'OK' } }  // Simulated response data
    // },
  ],
};
